export const MY_FLIGHT_SEARCH= 'MY_FLIGHT_SEARCH';
export const MY_FLIGHT_SEARCH_DATA_SUCCESS = 'MY_FLIGHT_SEARCH_DATA_SUCCESS';